<template>
  <div class="px-14 w-full h-full bg-white">
    <variables-empty-view v-if="isEmpty(variables)">
      <base-button variant="bordered" class="self-center p-3 font-medium text-lg"
                   @click="addVariablePlaceholder"
      >
        Create New Variable
      </base-button>
    </variables-empty-view>

    <template v-else>
      <variables-header :value="searchQuery"
                        @search-variable="searchQuery = $event"
                        @add-variable="addVariablePlaceholder"
      />

      <variables-table :search-query="searchQuery"/>
    </template>
  </div>
</template>

<script>
import VariablesHeader from '@/components/settings/variables/VariablesHeader.vue'
import VariablesTable from '@/components/settings/variables/VariablesTable.vue'
import VariablesEmptyView from '@/components/settings/variables/VariablesEmptyView.vue'
import variablesModule from '@/store/modules/variables.module'
import botModule from '@/store/modules/bot.module'
import marketModule from '@/store/modules/market.module'
import marketService from '@/services/amio/market.service'
import isEmpty from 'ramda/src/isEmpty'
import BaseButton from '@/components/base-components/BaseButton.vue'
import prepend from 'ramda/src/prepend'
import { ITEM_IDS } from '@/utils/editor.constants'

export default {
  name: 'Variables',

  components: { BaseButton, VariablesEmptyView, VariablesTable, VariablesHeader },

  data() {
    return {
      searchQuery: ''
    }
  },

  computed: {
    variables: {
      get() {
        return variablesModule.variables.get()
      },
      set(list) {
        variablesModule.variables.set(list)
      }
    },
    isLoading: variablesModule.variablesLoading,
    editedId: variablesModule.editedId,
    isVariableBeingAdded: variablesModule.isVariableBeingAdded
  },

  methods: {
    isEmpty,

    addVariablePlaceholder() {
      const newVariable = {
        name: '',
        value: '',
        bot_id: null,
        multi_bot_id: null,
        market_id: null,
        id: ITEM_IDS.NEW
      }
      this.variables = prepend(newVariable, this.variables)
    },

    // The scope picker (and the legacy bot-scope select) need the bot and market lists,
    // which are otherwise only loaded on the Bots settings page. Load them here so the
    // Variables page works standalone.
    async loadScopeData() {
      try {
        if (isEmpty(botModule.getBotList())) await botModule.setBotList()
        if (isEmpty(marketModule.getMarketList())) {
          marketModule.setMarketList(await marketService.list())
        }
      } catch (err) {
        // non-fatal: the picker degrades to "no bots/markets available"
      }
    }
  },

  mounted() {
    variablesModule.fetchVariables()
    this.loadScopeData()
  },

  destroyed() {
    this.variables = []
    variablesModule.editedId.set(null)
  }
}
</script>
